<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <router-link :to="{ name: 'New PoD' }" class="mt-2 mb-0 btn bg-gradient-success ms-lg-3 me-lg-0 me-auto mt-lg-0 ">
                    <span>{{ $t('key_pod_new_pod') }}</span>
                  </router-link>
                  <Filter :filter-status-selected="filterStatusSelected" @filter-change="onFilterChange"/>
                  <soft-button class="btn-icon ms-2 export" size color="primary" variant="outline" data-type="csv" @click="onDownloadExcel">
                    <span class="btn-inner--icon">
                      <i class="fa-solid fa-file-download me-2"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_orderListTableHeader_button_export_order') }}</span>
                  </soft-button>
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_orderListTableHeader_button_reload_order')" @change="getManifestos"/>
                </div>
              </div>
              <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Search space -->
                  <Searchbox :list-filters="listFilters" @change="onSearchChange"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!manifiestos"
            ref="genericTable"
            :items="manifiestos.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <template #row="manifest">
              <!-- <td style="width: 10rem" class="text-sm font-weight-bolder">
                <a class="cursor-pointer font-weight-bold font-weight-bold mb-0 picko-link" :title="$t('key_orderList_viewOrder')" @click="goToEdit(manifest)">
                  {{manifest.number}}
                </a>
              </td> -->
              <td style="width: 20rem" class="text-xs cursor-pointer font-weight-bolder mb-0 picko-link">
                <div class="d-flex">
                  <!-- <div class="my-auto form-check">
                    <input :id="item.id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item.id)" @change="changedSelection(item.id)" >
                  </div> -->
                  <a class="my-auto ms-3 picko">
                    <a class="font-weight-bold text-primary" href="#" @click.prevent="goToDetalle(manifest)">
                      {{ manifest.number }}
                    </a>
                  </a>
                </div>
              </td>
              <td style="width: 5rem" class="text-xs font-weight-bolder">
                {{ manifest.date ? $dateUtils.toDDMMYYYY(manifest.date) : null }}
              </td>
              <td style="width: 5rem" class="text-xs font-weight-bolder">
                {{ manifest.couries }}
              </td>
              <td style="width: 5rem" class="text-xs font-weight-bolder">
                {{ manifest.operator }}
              </td>
              <td style="width: 10rem" class="font-weight-bolder">
                <span v-if="manifest.status == 'PENDIENTE'" class="badge badge-pending badge-sm">{{ $t('key_pod_status_pending') }}</span>
                <span v-else-if="manifest.status == 'ENTREGADO'" class="badge badge-delivered badge-sm">{{ $t('key_pod_status_delivered') }}</span>
              </td>
              <td style="width: 5rem" class="text-xs font-weight-bolder">
                {{ $dateUtils.toDDMMYYYYHH(manifest.created_at) }}
              </td>
              <td style="width: 5rem" class="text-xs font-weight-bolder">
                <!-- <a style="cursor:pointer" class="mx-3" title="Ver pedido" @click="goToDetalle(pedido)">
                  <i class="fa-solid fa-eye text-secondary"></i>
                </a> -->
                <a
                  style="cursor:pointer"
                  class="mx-3"
                  :title="$t('key_podList_deletePod')"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteManifestModal"
                  @click="manifestToDelete = { ...manifest} ">
                  <i class="fa-solid fa-trash-can text-danger"></i>
                </a>
              </td>
            </template>
          </GenericTable>

        </div>
      </div>
    </div>
  </div>
  <ModalDeleteConfirmation :entity='manifestToDelete' @confirm-delete="deleteManifest" />
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      :show="showNotification"
      :title="notificationInfo.title"
      :description="notificationInfo.message"
      :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
      :color="notificationInfo.status=='success'?'success':'danger'"
      @close-handler="showNotification = !showNotification"
    />
  </div>
</template>

<script>

  import GenericTable from "./../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../picko_components/generic_components/Searchbox.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import Filter from "./components/Filter.vue";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import ModalDeleteConfirmation from "./components/ModalDeleteConfirmation.vue";
  import Cookies from 'js-cookie';

  export default {
    name: "ShipmentList",
    components: {
      SoftButton,
      Filter,
      SoftSnackbar,
      ModalDeleteConfirmation,
      GenericTable,
      ReloadButton,
      Searchbox
    },
    data() {
      return {
        filterStatusSelected: '',
        pagination: {
          total: 34,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        isLoading: false,
        urlUploadResource: "shipment",
        entityId: null,
        entityNumber: null,
        manifestToDelete: null,
        filters:{
          search: '',
          status:'',
          sort:{
            sort:'',
            order:''
          }
        },
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        showNotification: false,
      };
    },
    computed: {
      manifiestos() {
        return this.$store.state.manifiest.list.data;
      },
      manifestosExcel() {
        return this.$store.state.manifiest.manifestosExcel.data;
      },
      deleteManifestStatus() {
        return this.$store.state.manifiest.deleteManifest.status;
      },
      listFilters() {
        return this.$store.state.manifiest.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_pod_number'), sort: { sorteable: true, order: "" }, column: "number" },
          { title: this.$t('key_theader_pod_delivered_date'), sort: { sorteable: true, order: "" }, column: "date" },
          { title: this.$t('key_theader_pod_courier'), sort: { sorteable: true, order: "" }, column: "reference" },
          { title: this.$t('key_theader_pod_user'), sort: { sorteable: true, order: "" }, column: "operator" },
          { title: this.$t('key_theader_pod_status'), sort: { sorteable: true, order: "" }, column: "status" },
          { title: this.$t('key_theader_pod_created_on'), sort: { sorteable: true, order: "" }, column: "created_at" },
          { title: this.$t('key_theader_actions'), sort: { sorteable: false, order: "" } }
        ]
      },
      title() {
        return this.$t('key_podList_table_title');
      },
      description() {
        return this.$t('key_podList_table_description');
      }
    },
    watch: {
      manifiestos() {
        if(this.manifiestos){
          this.pagination.total= this.manifiestos.total;
          this.isLoading = false;
        }
      },
      deleteManifestStatus(newValue) {
        if(newValue['deleted']){
          this.notificationInfo = {
            title: this.$t('key_pod_successfully_deleted'),
            message: this.$t('key_pod_successfully_deleted_message'),
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotification();
          setTimeout(() => {
              this.getManifestos();
            }, 200);
        }

        if(newValue['error']){
          const { error: { error } } = newValue
          let message = this.$t('key_error_on_saving')
          if (error) {
            message = error
          }
          this.notificationInfo = {
            title: 'Ups! Lo Sentimos',
            message: message,
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotification();
        }
      },
      manifestosExcel() {
        if (this.$store.state.manifiest.manifestosExcel.error) {
          const error = this.$store.state.manifiest.manifestosExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo={
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification=true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else{
          this.downloadExcel(this.manifestosExcel);
          return;
        }
      },

    },
    mounted() {
      this.setUpFilters()
      this.getManifestos();
    },
    methods: {
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getManifestos(); 
      },
      getManifestos(){
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("manifiest/load",{
          filters: this.filters,
          pagination: this.pagination
        });
      },
      deleteManifest(value) {
        this.$store.commit("manifiest/deleteManifest", value);
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getManifestos(); 
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getManifestos(); 
      },
      // eslint-disable-next-line no-unused-vars
      headerChange(header){},
      goToDetalle(element){
        this.$router.push({ path: "/Operations/PoDs/EditPoD/" + element._id});
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getManifestos();

      },
      onFilterChange(value){
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getManifestos();

      },
      closeNotification(){
        const self= this;
        setTimeout(function () {
            self.showNotification=false
        },2700);
      },
      onDownloadExcel() {
        let savedLanguage = Cookies.get('Picko.language') || 'en';
        this.$store.commit("manifiest/manifestosExcel", {filters: this.filters, language: savedLanguage});
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        link.setAttribute('download', `PoDs-${formattedDate}`);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            URL.revokeObjectURL(link.href);
        }, 100);
      },    
    },
  };

</script>